// extracted by css-extract-rspack-plugin
export default {"banner":"banner--SaTXkuqs07wUVdW8","content":"content--Gjr_VABpKCIgnyyw","title":"title--GmQSNnrN4oQEXuiG","buttons":"buttons--ZkdsVtVJK0tw9O3Z"};